import { Templates } from '@hellohair/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StepField } from '../_shared/fields';
import { ModalList } from '../_shared/ModalList';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

/**
 * The MailDoB editor plus the consent block - the step collects e-mail and date
 * of birth and then submits the survey as succeeded, hence no "next step"
 * field in the logic tab.
 */
const MailDoBFinish: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataMailDoBFinish>(survey, index);
  const modals = draft.modals ?? [];

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <>
          <StepField
            label={t('editor.field.question')}
            value={draft.question}
            onChange={(value) => set('question', value)}
            multiline
          />
          <StepField
            label={t('editor.field.extra')}
            value={draft.extra}
            onChange={(value) => set('extra', value)}
            multiline
          />
          <StepField
            label={t('editor.field.consent')}
            value={draft.consent}
            onChange={(value) => set('consent', value)}
            multiline
          />
          <StepField
            label={t('editor.field.footnote')}
            value={draft.footnote}
            onChange={(value) => set('footnote', value)}
            multiline
          />

          <ModalList modals={modals} onChange={(next) => set('modals', next)} />
        </>
      }
      settings={
        <StepField label={t('editor.field.buttonLabel')} value={draft.next} onChange={(value) => set('next', value)} />
      }
    />
  );
};

export default MailDoBFinish;
